import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`

const ANIMATION_DURATION_SECONDS = 1.5

export const PrimarySkeleton = styled.div`
  width: 100%;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.color.lightGrey} 25%,
    ${({ theme }) => theme.color.mediumGrey} 50%,
    ${({ theme }) => theme.color.lightGrey} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} ${ANIMATION_DURATION_SECONDS}s infinite;
`
